module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    on: {
      "click": _vm.onWrapClick
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: _vm.maskClasses,
    style: ({
      zIndex: _vm.zIndex
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: _vm.mainClass,
    style: ({
      zIndex: _vm.zIndex
    })
  }, [_c('div', {
    class: _vm.wrapClasses,
    style: (_vm.mainStyles)
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionNames[0]
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    ref: "content",
    class: [_vm.prefixCls + '-content'],
    style: (_vm.heightStyle)
  }, [(_vm.showHead) ? _c('div', {
    class: [_vm.prefixCls + '-header']
  }, [_vm._t("header", [_c('div', {
    class: [_vm.prefixCls + '-title'],
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), (_vm.closable) ? _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.$_onCancel
    }
  }, [_vm._t("close", [_c('span', [_vm._v("×")])])], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "modal-body",
    class: [_vm.prefixCls + '-body'],
    style: (_vm.noPadding ? 'padding:0' : '')
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.footerHide) ? _c('div', {
    class: [_vm.prefixCls + '-footer']
  }, [_vm._t("footer", [_c('t-button', {
    attrs: {
      "type": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$_onCancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeCancelText))]), _vm._v(" "), _c('t-button', {
    attrs: {
      "loading": _vm.buttonLoading,
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$_onOk($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeOkText))])])], 2) : _vm._e()])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-297ad074"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = 355
// module chunks = 0